import styled from 'styled-components';

export const Pickerwrapper = styled.div`
  .rc-calendar-picker rc-calendar-picker-placement-bottomLeft {
    top: 104px;
  }
`;
